import React, { Fragment } from "react";
import Fade from "react-reveal/Fade";
import OthersPdf from "./OthersPdf";

function OthersBanner() {
  return (
    <Fragment>
      <div className="container governancemain motor">
        <div className="row arrticleAndBlogs">
          <div className="col-sm-12 heads govbanner perposal">
            <Fade up delay={500}>
              <h2 className="oswald">Other</h2>
            </Fade>
          </div>

          <div className="col-sm-12 heads text mymaxheight">
            <OthersPdf />
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default OthersBanner;
